/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/styles/bootstrap.css';
import './assets/styles/global.scss';
import './assets/styles/admin.scss';
import './assets/styles/authentication.scss';
import './assets/styles/public.scss';
import './assets/styles/classLesoonQuiz.scss';
import './assets/styles/dashboard.scss';
import './assets/styles/schoolmanager.scss';
import './assets/styles/nav-sidebar.scss';
import 'antd/dist/antd.less'
import './assets/styles/fontawesome.css';
import 'uikit/dist/css/uikit.min.css'
import 'uikit/dist/css/uikit-rtl.min.css'
import 'uikit/dist/css/uikit-rtl.css'
import 'uikit/dist/js/uikit.min'
import 'swiper/swiper.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Loader from './components/global/loaders/Loader';
import {Provider} from "react-redux";
import {createStore} from "redux";
import reducer from './redux/reducer'
import App from './App';
// import mapboxgl, {setRTLTextPlugin} from "mapbox-gl";
import setupAxios from "./api/setupAxios";
import axios from 'axios';

// mapboxgl.accessToken = 'pk.eyJ1IjoidGFoYTQ5NTQiLCJhIjoiY2s3MGFrbDc3MDQwMjNxcnU4bWR2NDBneCJ9.eMfcIKqIZ3NGJg7yTtvvWg';
// setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.0/mapbox-gl-rtl-text.js');

const rdx = createStore(reducer);

// setupAxios(axios);

ReactDOM.render(
    <React.Fragment>
        <Provider store={rdx}>
            <Suspense fallback={<Loader/>}>
                <App/>
            </Suspense>
        </Provider>
    </React.Fragment>,
    document.getElementById('root')
);

//admin > 09120000000 > 0000.00@gmail.com > 4232 > OTP True > مدیر سیستم
//student > 09900000001 > 0990003@gmail.com > 4232 > OTP False > دانش آموز
//parent > 09900000002 > 0990001@gmail.com > 4232 > OTP False > اولیا
//teacher > 09900000004 > 0990004@gmail.com > 4232 > OTP True > مدرس
//assistant > 09900000003 > 0990002@gmail.com > 4232 > OTP True > معاون - ناظر
//school manager > 09900000005 > 0990005@gmail.com > 4232 > OTP True > مدیر مدرسه

//docker-compose exec db mysql ziba -e "select * from users where phone = '09900000005'"
